// 用户信息详情
export const URI_GET_USERINFO = '/s1/user.getInfo'
// 手机验证码
export const URI_GET_PHONECODE = '/s1/user.sendCode'
// 绑定手机
export const URI_GET_BINDPHONE = '/s1/user.bindMobile'
// 用户登陆-切换账号
export const URI_MOBLIE_LOGIN = '/s1/user.mobileLogin'
// 微信绑定
export const URI_WECHAT_BINDING = '/s1/user.bindWechatAccount'
// 二维码链接
export const URL_LINK_SHARE = '/s1/team.share_info'
